<template>
  <div class="layout">
    <!-- 页面内容区 -->
    <div class="page-content">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'apply',
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/menu/apply.vue